module.exports = __webpack_public_path__ + "static/img/3.861100d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/eng/3.png
// module id = rLYn
// module chunks = 0